import { createFileRoute } from '@tanstack/react-router';

import { EditDepartmentModal } from '~/components/modals/department/EditDepartmentModal';
import { USER_ROLES } from '~/features/auth/roles';
import { Route as CustomerAdminDepartmentsRoute } from '~/routes/customer-administration/departments';
import { protectedRoute } from '~/utils/routesAuthorization';

const TEST_ID = 'customer-administration-department-details';

export const Route = createFileRoute(
  '/customer-administration/departments/$departmentId',
)({
  component: RouteComponent,
  params: {
    parse: (params) => ({ departmentId: params.departmentId }),
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.AbbottUser, USER_ROLES.AdminAbbott],
    });
  },
});

function RouteComponent() {
  const { departmentId } = Route.useParams();

  return (
    <EditDepartmentModal
      testID={TEST_ID}
      domain="CUSTOMER_ADMIN"
      onCloseRedirectPath={CustomerAdminDepartmentsRoute.fullPath}
      departmentId={departmentId}
    />
  );
}
